import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Pages from './routes';
import { QueryClientProvider, QueryClient } from 'react-query'
import { QueryParamProvider } from 'use-query-params';
import RouteAdapter from './routes/adapter';
import ptBr from 'antd/lib/locale-provider/pt_BR';
import { ConfigProvider } from 'antd';
import AuthVerify from './common/AuthVerify';
import { useMediaQuery } from 'react-responsive'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 2 * 1_000,
    }
  },
})

function App() { 

  return (
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <QueryParamProvider ReactRouterRoute={RouteAdapter}>
            <ConfigProvider locale={ptBr}>
              <Pages />
              <AuthVerify/> 
            </ConfigProvider>
          </QueryParamProvider>
        </BrowserRouter>

    </QueryClientProvider>
  );
}

export default App;
